import { Component, inject } from '@angular/core';
import { SoilGroupService } from '../proxy/planning/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  SoilGroupCreateDto,
  SoilGroupDto,
  SoilGroupExcelDownloadDto,
  SoilGroupUpdateDto,
} from '../proxy/planning/dtos/soil-group';
import { SOILGROUP_CONFIG, SOILGROUP_FIELDS } from './soil-group.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-soil-group',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, SoilGroupService, ConfirmationService],
  templateUrl: './soil-group.html',
  styleUrl: './soil-group.scss',
})
export class SoilGroup extends BaseCrudComponent<
  SoilGroupDto,
  SoilGroupCreateDto,
  SoilGroupUpdateDto,
  SoilGroupExcelDownloadDto
> {
  service = inject(SoilGroupService);
  config = SOILGROUP_CONFIG;
  fields = SOILGROUP_FIELDS;

  protected prepareUpdateDto(data: any, selected: SoilGroupDto): SoilGroupUpdateDto {
    return {
      name: data.name,
      code: data.code,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'SoilGroup';
  }
}
